<h2>File Upload Component</h2>

<div class="file-upload-grid">
	<div class="file-upload-column">
		<span class="label">File Upload</span>
		<app-file-upload
			[formControl]="fileUploadControl"
			placeholder="Arrastra o selecciona archivos"
		/>
		<app-ui-code-block [code]="generateCode({component: 'file-upload', formControl: 'fileUploadControl', placeholder: 'Arrastra o selecciona archivos'})" />
	</div>
</div>

<h2>Lang Switcher Component</h2>

<div class="lang-switcher-grid">
	<div class="lang-switcher-column">
		<span class="label">Inline</span>
		<app-lang-switcher [isFloating]="false" />
		<app-ui-code-block [code]="generateCode({component: 'lang-switcher', isFloating: false})" />
	</div>

	<div class="lang-switcher-column">
		<span class="label">Floating</span>
		<p class="note">👉 Mira abajo a la derecha de la pantalla</p>
		<app-lang-switcher [isFloating]="true" />
		<app-ui-code-block [code]="generateCode({component: 'lang-switcher', isFloating: true})" />
	</div>
</div>

<h2>Badge Component</h2>

<div class="badge-grid">
	<div class="badge-column">
		<span class="label">Small (12px)</span>
		<div class="badge-showcase">
			<app-badge value="3" badgeSize="small" severity="danger" />
		</div>
		<app-ui-code-block [code]="generateCode({component: 'badge', value: '3', badgeSize: 'small', severity: 'danger'})" />
	</div>

	<div class="badge-column">
		<span class="label">Large (16px)</span>
		<div class="badge-showcase">
			<app-badge value="10" badgeSize="large" severity="info" />
		</div>
		<app-ui-code-block [code]="generateCode({component: 'badge', value: '10', badgeSize: 'large', severity: 'info'})" />
	</div>

	<div class="badge-column">
		<span class="label">XLarge (20px)</span>
		<div class="badge-showcase">
			<app-badge value="99+" badgeSize="xlarge" severity="success" />
		</div>
		<app-ui-code-block [code]="generateCode({component: 'badge', value: '99+', badgeSize: 'xlarge', severity: 'success'})" />
	</div>
</div>

<h2>Avatar Component</h2>

<div class="avatar-grid">
	<div class="avatar-column">
		<span class="label">Con imagen</span>
		<app-avatar
			imageUrl="https://i.pravatar.cc/150?img=1"
			name="John Doe"
			extraInfo="Desarrollador"
		/>
		<app-ui-code-block [code]="generateCode({component: 'avatar', imageUrl: 'https://i.pravatar.cc/150?img=1', name: 'John Doe', extraInfo: 'Desarrollador'})" />
	</div>

	<div class="avatar-column">
		<span class="label">Sin imagen (iniciales)</span>
		<app-avatar
			name="Jane Smith"
			extraInfo="Diseñadora"
		/>
		<app-ui-code-block [code]="generateCode({component: 'avatar', name: 'Jane Smith', extraInfo: 'Diseñadora'})" />
	</div>
</div>

<h2>Confirm Dialog Component</h2>

<app-confirm-dialog />

<div class="confirm-dialog-grid">
	<div class="confirm-dialog-column">
		<span class="label">Diálogo de confirmación básico</span>
		<app-button
			label="Mostrar diálogo"
			(onClick)="showConfirmDialog()"
		/>
		<app-ui-code-block [code]="generateCode({component: 'confirm-dialog', methodName: 'showConfirmDialog'})" />
	</div>

	<div class="confirm-dialog-column">
		<span class="label">Diálogo de confirmación de eliminación</span>
		<app-button
			label="Eliminar elemento"
			variant="secondary"
			(onClick)="showDeleteConfirmDialog()"
		/>
		<app-ui-code-block [code]="generateCode({component: 'confirm-dialog', methodName: 'showDeleteConfirmDialog'})" />
	</div>
</div>

<h2>Phone Component</h2>

<div class="phone-grid">
	<div class="phone-column">
		<span class="label">Phone Input</span>
		<app-phone
			[formControl]="phoneControl"
			label="Teléfono"
			placeholder="000 000 000"
		/>
		<app-ui-code-block [code]="generateCode({component: 'phone'})" />
	</div>

	<div class="phone-column">
		<span class="label">Phone Format Pipe</span>
		<p class="phone-display">{{ phoneDisplayValue | phoneFormat }}</p>
		<app-ui-code-block [code]="generateCode({component: 'phone-format-pipe'})" />
	</div>
</div>

<h2>Tooltip Component</h2>

<div class="tooltip-grid">
	<div class="tooltip-column">
		<span class="label">Top (default)</span>
		<app-tooltip tooltipText="Tooltip en la parte superior">
			<app-button label="Hover me" variant="primary" />
		</app-tooltip>
		<app-ui-code-block [code]="generateCode({component: 'tooltip', tooltipText: 'Tooltip en la parte superior', tooltipPosition: 'top'})" />
	</div>

	<div class="tooltip-column">
		<span class="label">Bottom</span>
		<app-tooltip tooltipText="Tooltip en la parte inferior" [tooltipPosition]="'bottom'">
			<app-button label="Hover me" variant="primary" />
		</app-tooltip>
		<app-ui-code-block [code]="generateCode({component: 'tooltip', tooltipText: 'Tooltip en la parte inferior', tooltipPosition: 'bottom'})" />
	</div>

	<div class="tooltip-column">
		<span class="label">Left</span>
		<app-tooltip tooltipText="Tooltip a la izquierda" [tooltipPosition]="'left'">
			<app-button label="Hover me" variant="primary" />
		</app-tooltip>
		<app-ui-code-block [code]="generateCode({component: 'tooltip', tooltipText: 'Tooltip a la izquierda', tooltipPosition: 'left'})" />
	</div>

	<div class="tooltip-column">
		<span class="label">Right</span>
		<app-tooltip tooltipText="Tooltip a la derecha" [tooltipPosition]="'right'">
			<app-button label="Hover me" variant="primary" />
		</app-tooltip>
		<app-ui-code-block [code]="generateCode({component: 'tooltip', tooltipText: 'Tooltip a la derecha', tooltipPosition: 'right'})" />
	</div>

	<div class="tooltip-column">
		<span class="label">Custom delays</span>
		<app-tooltip
			tooltipText="Delay personalizado (1000ms / 500ms)"
			[showDelay]="1000"
			[hideDelay]="500"
			[tooltipPosition]="'top'">
			<app-button label="Hover me" variant="primary" />
		</app-tooltip>
		<app-ui-code-block [code]="generateCode({component: 'tooltip', tooltipText: 'Delay personalizado', showDelay: 1000, hideDelay: 500, tooltipPosition: 'top'})" />
	</div>
</div>
